export const calculate = {
  add: function (a, b) {
    if (
      typeof a == "undefined" ||
      typeof b == "undefined" ||
      a == null ||
      b == null
    ) {
      return NaN;
    }
    var c = 0;
    var d = 0;
    var e = 1;
    try {
      c = a.toString().split(".")[1].length;
    } catch (f) {}
    try {
      d = b.toString().split(".")[1].length;
    } catch (f) {}
    return (
      (e = Math.pow(10, Math.max(c, d))), (this.mul(a, e) + this.mul(b, e)) / e
    );
  },
  sub: function (a, b) {
    if (
      typeof a == "undefined" ||
      typeof b == "undefined" ||
      a == null ||
      b == null
    ) {
      return NaN;
    }
    var c = 0;
    var d = 0;
    var e = 1;
    try {
      c = a.toString().split(".")[1].length;
    } catch (f) {}
    try {
      d = b.toString().split(".")[1].length;
    } catch (f) {}
    return (
      (e = Math.pow(10, Math.max(c, d))), (this.mul(a, e) - this.mul(b, e)) / e
    );
  },
  mul: function (a, b) {
    if (
      typeof a == "undefined" ||
      typeof b == "undefined" ||
      a == null ||
      b == null
    ) {
      return NaN;
    }
    var c = 0;
    var d = a.toString();
    var e = b.toString();
    try {
      c += d.split(".")[1].length;
    } catch (f) {}
    try {
      c += e.split(".")[1].length;
    } catch (f) {}
    return (
      (Number(d.replace(".", "")) * Number(e.replace(".", ""))) /
      Math.pow(10, c)
    );
  },
  div: function (a, b) {
    if (
      typeof a == "undefined" ||
      typeof b == "undefined" ||
      a == null ||
      b == null
    ) {
      return NaN;
    }
    var c = 1;
    var d = 1;
    var e = 0;
    var f = 0;
    try {
      e = a.toString().split(".")[1].length;
    } catch (g) {}
    try {
      f = b.toString().split(".")[1].length;
    } catch (g) {}
    return (
      (c = Number(a.toString().replace(".", ""))),
      (d = Number(b.toString().replace(".", ""))),
      this.mul(c / d, Math.pow(10, f - e))
    );
  },
};



// WEBPACK FOOTER //
// ./src/utils/calculate.js